import React, { useRef } from 'react';
var VeltCommentsSidebarV2CloseButton = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comments-sidebar-close-button-v2", { ref: ref }, children));
};
export default VeltCommentsSidebarV2CloseButton;
